import expiryEditStore from "@/store/expiryEditStore";
import tradeDataStore from "@/store/tradeDataStore";
import ExpiryEditPopover from "./ExpiryEditPopover";

// LQC-2678 - renders the edit-expiry popover for a right-click, which has no
// React tree of its own. Mounted once per ActionSummaryTable; the cryptoID
// guard keeps a trade tile's menu from opening the popover on the main blotter
// too.
const ExpiryEditPopoverHost = ({ cryptoID }: { cryptoID?: string }) => {
  const target = expiryEditStore((state) => state.target);
  const closeExpiryEdit = expiryEditStore((state) => state.closeExpiryEdit);
  const currentTradeData = tradeDataStore((state) => state.tradeData);

  if (!target || target.cryptoID !== cryptoID) return null;

  const thisTrade = currentTradeData.find(
    (trade) => trade.esid === target.esid,
  );

  return (
    <ExpiryEditPopover
      esid={target.esid}
      expiryEnd={thisTrade?.expiryEnd}
      anchorRect={target.anchorRect}
      onClose={closeExpiryEdit}
    />
  );
};

export default ExpiryEditPopoverHost;
